const environment = {
  baseApiUrl: import.meta.env.VITE_BASE_API_URL ?? '',
  adminToken: import.meta.env.VITE_ADMIN_TOKEN ?? '',
};

export default environment;
